import styled from 'styled-components'

const ReactionWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export { ReactionWrap }
